import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import RatingDetailsList from './rating-details-list';
import { loadMorePaginationProp, SimpleLoadingComponent } from '../../utils/apollo';

const query = gql`
  query RepVisitsRatingDetailsList($id: ID!, $schoolYear: SchoolYear, $first: Int, $after: String) {
    viewer {
      id
      enabledFeatures
    }
    node(id: $id) {
      id
      ... on CommunityPerson {
        ratingsDetails(schoolYear: $schoolYear, first: $first, after: $after) {
          edges {
            node {
              id
              stars
              feedback
              comment
              isAnonymous
              reviewer {
                id
                name
                communityId
                field_user_institution
                field_user_institution_title
                field_user_institution_city
                field_user_institution_state
                field_user_institution_uuid
              }
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }
`;

const graphqlData = graphql(query, {
  options: ({ id, schoolYear }) => ({
    variables: {
      first: 5,
      id,
      schoolYear,
    },
    fetchPolicy: 'cache-and-network',
  }),
  props: loadMorePaginationProp(query),
});
export default SimpleLoadingComponent(graphqlData)(RatingDetailsList);
